import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone, faStop, faClock, faPause, faMicrophoneSlash, faPhoneSlash } from "@fortawesome/free-solid-svg-icons";
import RealTimeOscillator from "./RealTimeOscillator ";


const DoctorRecordingControls = ({
  recording,
  toggleRecording,
  voiceDuration,
  formatDuration,
  translationEngine,
  speechLanguage,
  micStatus,
  handleSaveAndGoHome,
  handleEndCall,
  isMuted,
  toggleMute,
  isCallEnded,
  doctortranscript
}) => {
  return (
    <main className="flex flex-col items-center justify-center space-y-12 mt-8">
      {/* Engine and Speech Language indicator */}
      {recording && (
        <div className="bg-blue-100 border border-blue-300 rounded-lg px-4 py-2 mb-4">
          <p className="text-blue-800 text-sm font-medium">
            Translation: {translationEngine === 'deepl' ? 'International Language' : 'Indian Languages'}

          </p>
          <p className="text-blue-800 text-sm font-medium">
            Speech: {speechLanguage === 'hi-IN' ? 'Hindi (India)' :
              speechLanguage === 'en-IN' ? 'English (India)' :
                speechLanguage === 'en-US' ? 'English (US)' :
                  speechLanguage === 'en-GB' ? 'English (UK)' :
                    speechLanguage === 'de-DE' ? 'German' :
                      speechLanguage === 'fr-FR' ? 'French' :
                        speechLanguage === 'es-ES' ? 'Spanish' :
                          speechLanguage === 'it-IT' ? 'Italian' :
                            speechLanguage === 'pt-PT' ? 'Portuguese (PT)' :
                              speechLanguage === 'pt-BR' ? 'Portuguese (Brazil)' :
                                speechLanguage === 'nl-NL' ? 'Dutch' :
                                  speechLanguage === 'pl-PL' ? 'Polish' :
                                    speechLanguage === 'ru-RU' ? 'Russian' :
                                      speechLanguage === 'ja-JP' ? 'Japanese' :
                                        speechLanguage === 'zh-CN' ? 'Chinese (Simplified)' :
                                          speechLanguage === 'ko-KR' ? 'Korean' :
                                            speechLanguage === 'id-ID' ? 'Indonesian' :
                                              speechLanguage === 'tr-TR' ? 'Turkish' :
                                                speechLanguage === 'uk-UA' ? 'Ukrainian' :
                                                  speechLanguage === 'kn-IN' ? 'Kannada (India)' :
                                                    speechLanguage === 'ta-IN' ? 'Tamil (India)' :
                                                      speechLanguage === 'te-IN' ? 'Telugu (India)' :
                                                        speechLanguage === 'bn-IN' ? 'Bengali (India)' :
                                                          speechLanguage === 'gu-IN' ? 'Gujarati (India)' :
                                                            speechLanguage === 'mr-IN' ? 'Marathi (India)' :
                                                              speechLanguage === 'pa-IN' ? 'Punjabi (India)' :
                                                                speechLanguage === 'ur-IN' ? 'Urdu (India)' : speechLanguage}}
          </p>
        </div>
      )}

      {/* <div className="flex flex-col items-center">
  <button
    onClick={toggleRecording}
    className={`flex items-center justify-center bg-custom-gradient text-white focus:outline-none focus:ring-2 focus:ring-offset-2 w-16 h-16 rounded-full shadow-lg transition-all duration-300 mb-8 hover:scale-110`}
  >
    <FontAwesomeIcon icon={recording ? faStop : faMicrophone} className="text-3xl" />
  </button>

  <p className="text-lg font-semibold text-[#FFFFFF]">
    {recording ? 'Pause Consultation' : 'Start Consultation'}
  </p>
</div> */}


      <div className="flex flex-col items-center gap-4">

        {/* Recording Button */}
        <button
          onClick={toggleRecording}
          disabled={isCallEnded}
          className={`flex items-center justify-center text-white focus:outline-none
      focus:ring-2 focus:ring-offset-2 w-16 h-16 rounded-full shadow-lg
      transition-all duration-300 hover:scale-110
      ${recording ? "bg-red-600 hover:bg-red-700" : "bg-custom-gradient"}
      ${isCallEnded ? "opacity-50 cursor-not-allowed" : ""}
    `}
        >
          <FontAwesomeIcon
            icon={recording ? faPause : faMicrophone}
            className="text-3xl"
          />
        </button>

        {/* Status */}
        <p className="text-lg font-semibold text-white">
          {isCallEnded
            ? "Consultation Ended"
            : recording
              ? "Consultation In Progress"
              : "Start Consultation"}
        </p>

        {/* Action Buttons */}
        <div className="flex items-center gap-3">

          {/* Mute / Unmute */}
          <button
            onClick={toggleMute}
            disabled={!recording || isCallEnded}
            className={`px-5 py-2 rounded-lg font-medium shadow-md transition-all
        ${isMuted
                ? "bg-yellow-500 hover:bg-yellow-600 text-white"
                : "bg-gray-600 hover:bg-gray-700 text-white"
              }
        ${!recording || isCallEnded
                ? "opacity-50 cursor-not-allowed"
                : ""
              }
      `}
          >
            <FontAwesomeIcon
              icon={isMuted ? faMicrophoneSlash : faMicrophone}
              className="mr-2"
            />
            {isMuted ? "Unmute" : "Mute"}
          </button>

          {/* End Call */}
          <button
            onClick={handleEndCall}
            disabled={isCallEnded }
            className={`px-6 py-2 text-white font-semibold rounded-lg shadow-md transition-all ${
    isCallEnded
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-red-600 hover:bg-red-700"
  }`}
          >
            <FontAwesomeIcon icon={faPhoneSlash} className="mr-2" />
            End Recording
          </button>

        </div>

        {/* Mute Indicator */}
        {recording && isMuted && (
          <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-sm font-medium">
            🔇 Microphone muted. Recording timer continues but transcript is not being captured.
          </div>
        )}

      </div>

      {/* Save and Go Home Button
{!recording && (
  <button
    onClick={handleSaveAndGoHome}
    className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 mt-4"
  >
    Save and Go Home
  </button>

)}
*/}

      {/* <p className="text-indigo-800 text-xl text-center mt-6 flex items-center justify-center">
        <FontAwesomeIcon icon={faClock} className="mr-2 text-indigo-500" />
        Duration of conversation:{" "}
        <span className="notranslate font-semibold ml-2">
          {formatDuration(voiceDuration)}
        </span>
      </p>
      <RealTimeOscillator sentiment={sentiment} /> */}

    </main>
  );
};

export default DoctorRecordingControls;
